import { Box, AspectRatio, Text, Flex } from '@chakra-ui/react'
import Image from 'next/image'
import { COLOR } from './'

const Ingredient = () => {
  return (
    <Box className="w-full h-full relative mx-auto">
      <AspectRatio
        ratio={913 / 564}
        className="w-full"
        w="100%"
        position="relative"
      >
        <Image
          src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/1739427293908-1739427355296.jpg"
          alt="ingradient section"
          width={1260}
          height={601}
          className="w-full h-full object-cover"
        />
      </AspectRatio>

      <Box className="absolute inset-0 z-10">
        <Flex className="flex-col w-[30%] absolute top-[15%] left-[65%]">
          <Text
            color={COLOR.LIGHT}
            className="text-[6px] md:text-xs lg:text-base font-bold"
          >
            Beta-glucans derived from Ganodermalucidum mycelium (Reishi
            Mushroom)
          </Text>
          <Text
            color={COLOR.LIGHT}
            className="text-[6px] md:text-xs lg:text-base font-semibold mb-2"
          >
            (Ganoderma lucidum polysaccharide):
          </Text>
          <Text
            color={COLOR.LIGHT}
            className="text-[6px] md:text-xs lg:text-base"
          >
            This ingredient is certified under the FDA's GRAS standard, with
            certification number GRN No.413, indicating that it is recognized as
            safe. Additionally, it holds a USDA National Organic Program (NOP)
            ID number 6220007432 for certified organic processing and handling.
          </Text>
        </Flex>

        <Flex className="flex-col  w-[26%] absolute top-[62%] md:left-[30%] left-[28%]">
          <Text
            color={COLOR.LIGHT}
            className="text-[6px] md:text-xs lg:text-base font-bold"
          >
            The ingredient Salvia miltiorrhiza extract (Red Sage)
          </Text>
          <Text
            color={COLOR.LIGHT}
            className="text-[6px] md:text-xs lg:text-base font-semibold mb-2"
          >
            (Salvia miltiorrhiza extract):
          </Text>
          <Text
            color={COLOR.LIGHT}
            className="text-[6px] md:text-xs lg:text-base "
          >
            Developed by the Taiwan Agricultural Technology Research Institute
            (ATRI), it is formulated to fortify hair roots and nourish the
            scalp.
          </Text>
        </Flex>

        <Flex className="flex-col w-[350px] absolute top-[82%] right-[5%]">
          <Text
            color={COLOR.LIGHT}
            className="text-[6px] md:text-xs lg:text-base text-right font-bold lg:mb-4 md:mb-2 sm:mb-1"
          >
            Enhanced with <br className="sm:inline hidden" /> additional
            ingredients:
          </Text>
          <Text
            color={COLOR.LIGHT}
            className="text-[6px] md:text-xs text-right"
          >
            Enhanced with additional ingredients:
            <br />
            Reishi Mushroom (Ganoderma lucidum polysaccharide)
            <br />
            Red Sage (Salvia miltiorrhiza extract)
          </Text>
        </Flex>
      </Box>
    </Box>
  )
}

export default Ingredient
